import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate  } from "react-router-dom";

const FuelingReport = () => {
  const frmRef = useRef({});
  const navigate  = useNavigate ();
  const handleButtonClick = () => {
    navigate("/operationalwise");
  };
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [wareHouseData, setWareHouseData] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);

  const [vehiclelist, setVehiclelist] = useState();
  const [vmerId, setvmerId] = useState(0);
  const [fuelingType, setFuelingType] = useState(0);

  const [data, setData] = useState([]);

  
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const { sendRequest: getEmp } = useHttp();
  const getAllEmp = () => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  };

  const { sendRequest: getWarehouseData } = useHttp();
  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setWareHouseData(res);
        }
      }
    );
  };

  const { sendRequest: getVehicle } = useHttp();
  const getVehicleData = () => {
    getVehicle(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
      },
      (res) => {
        if (res) {
          var vehicle = res.filter((x) => x.vmeClassific == "Vehicle");

          setVehiclelist(vehicle);
        }
      }
    );
  };
  useEffect(() => {
    getVehicleData();
    getWarehouseDetail();
    getAllEmp();
  }, []);

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

//  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: fuelingData } = useHttp();

  const FillReport = (employeeId, warehouseId, vehicleId, fuelingType) => {
    var d = new Date(selectedToDate);

    d.setDate(d.getDate() + 1);

    // //console.log("d", d);
    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    //var tdate=moment(selectedToDate).format("DD/MM/YYYY");

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }
    if (warehouseId > 0) {
      urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    }
    if (vehicleId > 0) {
      urlfilter = urlfilter + `&vehicleId=${vehicleId}`;
    }
    if (fuelingType != "") {
      urlfilter = urlfilter + `&fuelingType=${fuelingType}`;
    }

    var url = `/api/fuelingMIS/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    //console.log(url);

    fuelingData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0, 0, "");
  }, [fuelingData]);

  const fieldsToExport = [
    "cleaningWashingDate",
    "cleaningWashingTime",
    "cleaningWashingNo",
    "employeeName",
    "lotNo",
    "TotalinputWeight",
    "unitAbbreviation",
    "waterTemperature",
    "detergentinWater",
    "desiredTemp",
    "waterTreatmentDipping.exposureTime",
    "waterTreatmentDipping.fungicideName",
    "waterTreatmentDipping.fungicideConcentration", 
    "waxCoating",
    "remark",
  ];

  const customHeaders = [
    "Date",
    "Time",
    "Doc No",
    "Farm Manager",
    "Lot No",
    "Input Quantity",
    "Unit",
    "Water Temperature",
    "Detergent In Water ",
    "Desired Temperature",
    "Exposure Time",
    "Fungicide Name",
    "Fungicide Concentration",
    "Wax Coating",
    "Reamrk/Note",
  ];

  const handleExportExcel = () => {
    const filename = "LotCreationDetail.xlsx";
    //console.log(fieldsToExport, customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
      <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Fuelling Detail Reports</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
         


            <div className="row">

            <div className="col-md-3">
            <label htmlFor={"executive_officer"}>{"Employee Name"}</label>
            <select
              id="emp_id"
              className="form-control"
              ref={(el) => (frmRef.current["emp_id"] = el)}
              value={employeeId}
              onChange={(e) => {
                setEmployeeId(e.target.value);
              }}
            >
              <option value="">Select</option>
              {employeeData &&
                employeeData.map((x) => (
                  <option key={x.userId}  value={x.empId}>
                    {x.employeeName}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-3">
            <label htmlFor={"warehouse_name"}>{"Warehouse Name"}</label>

            <select
              id="warehouse_name"
              className="form-control"
              ref={(el) => (frmRef.current["warehouse_name"] = el)}
              required
              value={warehouseId}
              onChange={(e) => {
                setWarehouseId(e.target.value);
              }}
            >
              <option>Select</option>
              {wareHouseData &&
                wareHouseData.map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-md-3">
            {" "}
            <label htmlFor={"vehicle_id"}>{"Vehicle"}</label>
            <select
              id="vmerId"
              required
              className="form-control"
              ref={(el) => (frmRef.current["vmerId"] = el)}
              value={vmerId}
              onChange={(e) => {
                setvmerId(e.target.value);
              }}
            >
              <option value="">Select</option>
              {vehiclelist &&
                vehiclelist.map((x) => (
                  <option key={x.vmerId} vmer-id={x.vmerId} value={x.vmerId}>
                    {x.vmeNo}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-3">
            <label htmlFor={"Fueling Type "}>{"Fueling Type"}</label>
            <select
              id="emp_id"
              className="form-control"
              required
              ref={(el) => (frmRef.current["fuelingType"] = el)}
              value={fuelingType}
              onChange={(e) => {
                setFuelingType(e.target.value);
              }}
            >
              <option value="">Select</option>
              <option value="In-warehouse">{"In-warehouse"}</option>
              <option value="External">{"External"}</option>
            </select>
          </div>

          </div>
            <div className="row">
            
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(employeeId, 0);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                 
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "1.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                       
                        <th> Date </th>

<th> Doc No </th>
<th> Fueling Time </th>

<th>Employee Name</th>

<th> Fueling Type </th>
<th>Vehicle Number</th>
<th>Driver Name </th>
<th>Meter Reading</th>
<th> Fuel Name</th>
<th>Fuel Quantity </th>
<th>Unit</th>
<th>Amount</th>
<th>Reamrk/Note</th>

                        </tr>
                      </thead>

                      {currentItems &&
                        currentItems.map((itm, i) => {
                          return (
                            <tr key={i} className="tablerowview">
                                 <td> {itm.fuelingDate} </td>

<td> {itm.fuelingNo} </td>
<td>{moment(itm.timeStamp, "HH:mm:ss").format("hh:mm A")}</td> 

<td>{itm.employeeName}</td>

<td> {itm.fuelingType} </td>
<td> {itm.vmeNo} </td>
<td> {itm.driverName} </td>
<td> {itm.meterReading} </td>

<td> {itm.fuelProductName} </td>
<td> {itm.refillQuantity} </td>
<td> {itm.unitAbbreviation} </td>

<td> {itm.totalAmount} </td>

<td> {itm.remark} </td>
                            </tr>
                          );
                        })}
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FuelingReport;
